import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ProductRoutingModule } from "./product-routing.module";
import { ProductComponent } from "./product.component";
import { InterestedFormComponent } from "./interested-form/interested-form.component";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { NgxJsonLdModule } from '@ngx-lite/json-ld';

@NgModule({
  declarations: [ProductComponent, InterestedFormComponent],
  imports: [
    CommonModule,
    ProductRoutingModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    NgxJsonLdModule,
  ]
})
export class ProductModule {}
